import { LEGAL_DOCUMENTS } from './legalConfig';

export type LegalSection = {
  title: string;
  body: string[];
};

export type LegalDocumentContent = {
  badge: string;
  title: string;
  intro: string;
  warning: string;
  sections: LegalSection[];
};

export const LEGAL_CONTENT: Record<'terms' | 'privacy', LegalDocumentContent> = {
  terms: {
    badge: `Version ${LEGAL_DOCUMENTS.terms.version}`,
    title: 'Conditions Générales de Vente',
    intro:
      'Ces conditions encadrent les réservations d\'expéditions Jacana Nature, les modalités de paiement, les annulations et les responsabilités de chaque partie.',
    warning:
      'Ce texte constitue une base produit/technique sérieuse, mais il doit être relu et validé par un professionnel du droit avant toute mise en production définitive.',
    sections: [
      {
        title: 'Objet',
        body: [
          'Jacana Nature propose des sorties et expéditions guidées. Toute réservation vaut demande de participation à la date, au tarif et selon les modalités affichées au moment de la commande.',
        ],
      },
      {
        title: 'Réservation et paiement',
        body: [
          'La réservation n\'est définitive qu\'après validation du paiement ou, pour les paiements différés, après vérification effective par Jacana Nature.',
          'Les modes de paiement proposés sur la fiche de sortie font foi. Les frais éventuels liés au moyen de paiement du client restent à sa charge sauf mention contraire.',
        ],
      },
      {
        title: 'Prix',
        body: [
          'Les prix affichés sur le site s\'entendent en euros et s\'appliquent par participant sauf mention contraire. Le montant total de la réservation est récapitulatif avant validation.',
        ],
      },
      {
        title: 'Annulation par le client',
        body: [
          'Les conditions d\'annulation applicables doivent être confirmées juridiquement. Techniquement, le parcours actuel bloque l\'annulation standard à moins de 24 heures avant la sortie.',
          'Si un remboursement est dû, il suit le statut de paiement et les règles internes de Jacana Nature.',
        ],
      },
      {
        title: 'Annulation ou modification par Jacana Nature',
        body: [
          'Jacana Nature peut reporter, modifier ou annuler une sortie pour raison de sécurité, de météo, de logistique ou d\'indisponibilité. Dans ce cas, le client est informé et une solution adaptée est proposée.',
        ],
      },
      {
        title: 'Participation et responsabilité',
        body: [
          'Le participant s\'engage à fournir des informations exactes, à respecter les consignes de sécurité et à signaler tout besoin particulier utile à l\'organisation de la sortie.',
          'Jacana Nature ne peut pas être tenue responsable d\'informations omises ou inexactes qui empêcheraient une organisation adaptée.',
        ],
      },
      {
        title: 'Droit applicable et contact',
        body: [
          'Le droit applicable et les modalités de règlement des litiges doivent être complètes et vérifiées juridiquement avant publication finale.',
          'Pour toute question relative à une réservation, le point de contact opérationnel est l\'adresse email visible dans l\'application.',
        ],
      },
    ],
  },
  privacy: {
    badge: `Version ${LEGAL_DOCUMENTS.privacy.version}`,
    title: 'Politique de confidentialité',
    intro:
      'Cette politique explique quelles données Jacana Nature traite, pour quelles finalités, combien de temps elles sont conservées et quels choix sont proposés aux utilisateurs.',
    warning:
      'Ce document doit également être relu et validé juridiquement. Il est structuré pour être exploitable techniquement et compréhensible par l\'utilisateur.',
    sections: [
      {
        title: 'Données collectées et traitées',
        body: [
          'Selon les parcours utilisés, Jacana Nature peut traiter votre identité, votre email, votre téléphone, vos réservations, le mode de paiement choisi, ainsi que les informations opérationnelles nécessaires à l\'organisation d\'une sortie.',
          'Si vous saisissez des allergies, contraintes de santé ou besoins particuliers, ces données ne sont traitées que pour préparer et sécuriser la sortie concernée.',
        ],
      },
      {
        title: 'Finalités du traitement',
        body: [
          'Les données obligatoires servent à créer un compte, traiter une réservation, suivre un paiement, communiquer des informations de service et gérer la relation client.',
          'Les consentements optionnels, comme la réception d\'emails marketing ou la mesure d\'audience, sont gérés séparément et peuvent être modifiés indépendamment.',
        ],
      },
      {
        title: 'Base de traitement',
        body: [
          'Les données nécessaires à l\'exécution du service reposent sur la gestion de la relation contractuelle. Les emails marketing et la mesure d\'audience reposent sur des choix optionnels distincts.',
        ],
      },
      {
        title: 'Destinataires et sous-traitants',
        body: [
          'Les données sont hébergées et traitées via Firebase pour l\'authentification, la base de données et certaines fonctions serveur. Les paiements peuvent passer par Mollie quand ce mode est proposé.',
        ],
      },
      {
        title: 'Conservation',
        body: [
          'Les données de compte et de réservation sont conservées tant qu\'elles restent nécessaires au suivi de la relation client, à l\'exploitation du service et aux obligations administratives ou comptables applicables.',
          'Les preuves d\'acceptation sont historisées avec une version documentaire et un horodatage serveur.',
        ],
      },
      {
        title: 'Vos choix et vos droits',
        body: [
          'Vous pouvez consulter et modifier vos préférences optionnelles depuis votre espace utilisateur lorsqu\'il est disponible.',
          'Les demandes d\'accès, de rectification, de suppression ou d\'opposition doivent être traitées via un canal de contact à formaliser juridiquement.',
        ],
      },
      {
        title: 'Cookies et mesure d\'audience',
        body: [
          'Les outils de mesure d\'audience non essentiels ne doivent pas être actives avant votre choix explicite. Vous pouvez accepter ou refuser cette mesure, puis modifier ce choix plus tard.',
        ],
      },
    ],
  },
};